import { render, staticRenderFns } from "./FormLogo.vue?vue&type=template&id=154fae2b&"
import script from "./FormLogo.vue?vue&type=script&lang=js&"
export * from "./FormLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports